import { fetchFun } from './fetchFun';

// CFS (fetchRawJournalData) and SES (fetchSesRawJournalData) both need the raw journal
// report, and DefaultLayout dispatches both in the same prefetch -- which sent the identical
// GET /api/getJournalReport/:userId twice. That endpoint returns the whole decompressed
// journal (MBs), and each copy ties up the single backend process for the duration, so
// callers asking while a request for the same user is already in flight share it instead.
// The entry is dropped once the request settles, so a later explicit refetch still goes
// to the server.
const inFlight = new Map();

export const fetchJournalReportOnce = (userId) => {
    if (inFlight.has(userId)) return inFlight.get(userId);
    const request = fetchFun(`/api/getJournalReport/${userId}`, 'GET')
        .finally(() => inFlight.delete(userId));
    inFlight.set(userId, request);
    return request;
};
